export default {
  meta: {
    title: '获取高德三种adcode'
  }
};
